// The prepaint script is a literal string: function.toString() changes under
// client minification and would mismatch the prerender during hydration.
export const prepaintUnderlineEngineScript = `
  // Run before CSS paints; literal text stays identical in server and client bundles.
  (function () {
    var ua = navigator.userAgent;
    var webkit = /iP(?:hone|ad|od)/.test(ua) ||
      (/Safari\\//.test(ua) && !/(?:Chrome|Chromium|CriOS|Edg|EdgiOS|OPR|FxiOS)\\//.test(ua));
    var chromium = /(?:Chrome|Chromium|Edg|OPR)\\//.test(ua);
    var engine = webkit ? 'webkit' :
      chromium && /Android/.test(ua) ? 'android-chromium' :
      chromium ? 'chromium' : 'other';
    document.documentElement.setAttribute('data-underline-engine', engine);
    if (engine === 'chromium') {
      var major = /(?:Chrome|Chromium)\\/(\\d+)/.exec(ua);
      document.documentElement.setAttribute('data-underline-chromium',
        major && Number(major[1]) >= 154 ? '154-plus' : 'old');
    }
  })();
`;

export function classifyUnderlineEngine(ua: string) {
  if (
    /iP(?:hone|ad|od)/.test(ua) ||
    (/Safari\//.test(ua) &&
      !/(?:Chrome|Chromium|CriOS|Edg|EdgiOS|OPR|FxiOS)\//.test(ua))
  ) {
    return 'webkit';
  }
  if (/Android/.test(ua) && /(?:Chrome|Chromium|Edg|OPR)\//.test(ua)) {
    return 'android-chromium';
  }
  return /(?:Chrome|Chromium|Edg|OPR)\//.test(ua) ? 'chromium' : 'other';
}

export function classifyUnderlineChromium(ua: string) {
  const major = /(?:Chrome|Chromium)\/(\d+)/.exec(ua)?.[1];
  return major && Number(major) >= 154 ? '154-plus' : 'old';
}
